import axiosInstance from "../axiosInstance";

export const fetchProcessUsage = async (fromDate, toDate, signal) => {
  const response = await axiosInstance.post("/tenant/usage/all", {
    fromDate: new Date(fromDate).toISOString(),
    toDate: new Date(toDate).toISOString(),
  }, { signal });

  if (!Array.isArray(response.data)) {
    throw new Error("The usage API returned an unexpected response.");
  }
  return response.data;
};
